/* eslint-disable import/no-unused-modules */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

const selectLiveData = state => state.live;

const makeSelectLivePanelsData = createDeepEqualSelector(selectLiveData, live => live.panels);

export default makeSelectLivePanelsData; // Disabled eslint as this WIP
